var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m45.879 15.695c2.3086 0 4.1836 1.8477 4.1836 4.1289s-1.875 4.1289-4.1836 4.1289h-31.516v61.48h62.273v-31.297c0-2.2812 1.8711-4.1289 4.1797-4.1289 2.3125 0 4.1836 1.8477 4.1836 4.1289v31.297c0 4.5625-3.7461 8.2617-8.3633 8.2617h-62.273c-4.6172 0-8.3633-3.6992-8.3633-8.2617v-61.48c0-4.5625 3.7461-8.2578 8.3633-8.2578zm26.844 0.46094 11.316 11.312-36.789 36.789c-0.69922 0.69922-1.6094 1.1484-2.5898 1.2773l-11.535 1.5352 1.5352-11.539c0.12891-0.98047 0.57812-1.8906 1.2773-2.5898zm8.8398-8.8398c1.7578-1.7539 4.6055-1.7539 6.3633 0l4.9492 4.9531c1.7578 1.7539 1.7578 4.6055 0 6.3633l-4.5938 4.5938-11.316-11.312z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.cdd5ce150932c2518dcb99064f1dcce4.svg";
export { ForwardRef as ReactComponent };